/* eslint-disable no-console */
const autopopulateZipcode = () => {
  const removeMenu = () => {
    const selector = '.autofill-option-list';
    const menu = document.querySelector(selector);
    if (menu) {
      document.removeEventListener('click', removeMenu);
      menu.removeEventListener('click', onMenuClick); /* eslint-disable-line no-use-before-define */
      menu.remove();
    }
  };

  const onMenuClick = (event) => {
    const btn = event.target;
    if (btn.nodeName === 'BUTTON') {
      // Populate other form dropdowns
      const form = btn.closest('.site-form');
      let cityIpt = form.querySelector('[name="City"]');
      let stateIpt = form.querySelector('[name="State"]');
      let zipIpt = form.querySelector('[name="ZipCode"]');
      // For checkout, billing and shipping address fields are
      // contained w/in the same form. Need to be able to target
      // separately... look for wrapping fieldset, and then form
      // elements by name
      if (zipIpt === null) {
        const fieldset = btn.closest('fieldset');
        if (fieldset.id === 'AddressContainer') {
          cityIpt = form.querySelector('[name="ShippingAddress.City"]');
          stateIpt = form.querySelector('[name="ShippingAddress.State"]');
          zipIpt = form.querySelector('[name="ShippingAddress.PostalCode"]');
        } else if (fieldset.id === 'billingAddressContainer') {
          cityIpt = form.querySelector('[name="BillingInformation.City"]');
          stateIpt = form.querySelector('[name="BillingInformation.State"]');
          zipIpt = form.querySelector('[name="BillingInformation.PostalCode"]');
        }
      }
      if (cityIpt !== null) {
        cityIpt.value = btn.getAttribute('data-city');
      }
      if (stateIpt !== null) {
        stateIpt.value = btn.getAttribute('data-state');
      }
      if (zipIpt !== null) {
        zipIpt.value = btn.getAttribute('data-zip');
      }
      removeMenu();
    }
  };

  const addListItemsToMenu = (data) => {
    const menu = document.querySelector('.autofill-option-list');
    const ul = menu.querySelector('ul');
    ul.innerHTML = '';
    data.forEach((item) => {
      const li = document.createElement('li');
      li.innerHTML = `<button type="button" tabindex="0" data-city="${item.City}" data-state="${item.State}" data-zip="${item.Zip}">${item.City}, ${item.State} ${item.Zip}</button>`;
      ul.appendChild(li);
    });
  };

  const buildMenu = (ipt, data) => {
    const wrapper = ipt.parentNode;
    let menu = document.querySelector('.autofill-option-list');
    if (menu) {
      addListItemsToMenu(data);
      return;
    }
    const div = document.createElement('div');
    div.classList.add('autofill-option-list');
    const ul = document.createElement('ul');
    div.appendChild(ul);
    wrapper.appendChild(div);
    addListItemsToMenu(data);
    // Add button event listeners
    menu = document.querySelector('.autofill-option-list');
    menu.addEventListener('click', onMenuClick);
    document.addEventListener('click', removeMenu);
  };

  const getZipCodeMatches = param => (
    new Promise((resolve, reject) => {
      fetch(`/api/GetZipCityList?param=${param}`, {
        method: 'GET',
        headers: {
          accept: 'application/json',
          'content-type': 'application/json',
        },
      })
        .then((response) => {
          if (response.ok) {
            response.json().then(resolve);
          } else {
            response.json().then(reject);
          }
        })
        .catch(console.error);
    })
  );

  const queryZipCode = (ipt) => {
    const { value } = ipt;
    if (value.length >= 2) {
      getZipCodeMatches(value)
        .then((data) => {
          buildMenu(ipt, data);
        });
    }
    if (value.length < 2) {
      removeMenu();
    }
  };

  const addKeyupForZipCodeInputs = (event) => {
    if (event.target.classList.contains('autopopulate-zipcode')) {
      const ipt = event.target;
      queryZipCode(ipt);
    }
  };

  const init = () => {
    document.addEventListener('keyup', addKeyupForZipCodeInputs);
  };
  init();
};

export default autopopulateZipcode;
/* eslint-enable no-console */
